import * as React from 'react';
import { useContext, useState, useCallback } from 'react';
import { Icon } from '.'
import { TabBar } from '.';
import { colors } from '../../shared-exports';
import { RouteContext, UserContext, EditorContext, DataContext } from '../../providers';
import useWindowSize from '../utils/windowSize';
import { GalleryIconComponent, HomeIconComponent, UserIconComponent, OwnproductIconComponent, FotoIconComponent } from '../icons';
// px, percent removed — raw values used inline
import { ModelHttpService } from '../../services';
import { ModelName } from '../../models/names';
/** The Tab menu shown in the footer of the application */

export function Tabs() {
	const router = useContext(RouteContext);
	const user = useContext(UserContext);
	const editor = useContext(EditorContext);
	const data = useContext(DataContext);

	const [imageonerror, setImageonerror] = useState(false);
	const { isDesktop } = useWindowSize();

	const openModal = useCallback(async (template: ISheetProductTemplate) => {
		editor.add(template);
	}, [editor]);

	const onPressedProjectTab = useCallback(async () => {
		// Ignore if we are on the first project page already
		if (router.view.path == "/project/list") {
			return;
		}
		// If on any page belonging to the project tab, go  to the list of projects
		if (router.view.path.indexOf("/project") > -1) {
			router.push('/project/list', 'none');
			return;
		}
		// Otherwise go direct to the latest visited projectpage
		router.push(router.tabs.project, 'none');
	}, [router]);

	const onPressedFotoTab = useCallback(async () => {
		const fotaTemplate: any = data.templates && data.templates.find((item) => item.name === "Fota produkt") || undefined;
		if (!fotaTemplate) {
			const fetchedTemplate: any = await new ModelHttpService().findCategoryWiseProduct(ModelName.SheetProductTemplate, { categoryName: "Egen produkt" });
			if (fetchedTemplate) {
				const foundTemplate = fetchedTemplate && fetchedTemplate.templates.find((templ: any) => templ.name === "Fota produkt") || undefined;
				//@ts-ignore
				foundTemplate.openFotoComponent = true;
				editor.add(foundTemplate);
				await data.updateState({ templates: data.templates.concat(foundTemplate) });
			} else {
				throw new Error("No template found");
			}
		} else {
			fotaTemplate.openFotoComponent = true;
			editor.add(fotaTemplate);
		}
		// Ignore if we are on the first project page already
		if (router.view.path == "/foto") {
			return;
		}
		// If on any page belonging to the project tab, go  to the list of projects
		if (router.view.path.indexOf("/foto") > -1) {
			router.push('/foto', 'none');
			return;
		}
		// Otherwise go direct to the latest visited projectpage
		router.push(router.tabs.foto, 'none');
	}, [data, editor, router]);

	const onPressedProductTab = useCallback(async () => {
		// Ignore if we are on the first product page already
		if (router.view.path == "/product/gallery") {
			return;
		}
		// If on any page belonging to the project tab, go  to the gallery
		// Make sure we deselect any selected categories
		if (router.view.path.indexOf("/product") > -1) {
			await editor.updateState({ categories: [] });
			router.push('/product/gallery', 'none');
			return;
		}
		// Otherwise go direct to the latest visited projectpage
		router.push('/product/gallery', 'none');

	}, [router, editor]);

	const ownIconComponent = useCallback(async () => {
		if (router.view.path == "/ritaproduct") {
			return;
		}
		const ritaTemplate: any = data.templates && data.templates.find((templ) => templ.name === "Rita produkt") || undefined
		if (ritaTemplate) {
			ritaTemplate.openFotoComponent = false;
			openModal(ritaTemplate);
		} else {
			const fetchedTemplate: any = await new ModelHttpService().findCategoryWiseProduct(ModelName.SheetProductTemplate, { categoryName: "Egen produkt"});
			if (fetchedTemplate) {
				const ritaTemplate = fetchedTemplate.templates.find((item: any) => item.name === "Rita produkt");
				openModal(ritaTemplate!)
				await data.updateState({ templates: data.templates.concat(ritaTemplate) });
			}
		}
	}, [router, data, openModal]);

	const onPressedSettingsTab = useCallback(async () => {
		// Ignore if we are on the first product page already
		if (router.view.path == "/settings") {
			return;
		}
		// Otherwise go direct to the latest visited projectpage
		router.push(router.tabs.settings, 'none');
	}, [router]);

	const imageError = useCallback((e: any) => {
		if (e.target.onerror === null) {
			setImageonerror(true);
			return e.target.onerror
		}
	}, []);

	const { translate } = data;
	if (!router.view.path) {
		router.view.path = "/project"
	}
	const tabs = [
		{
			key: 'Projekt',
			title: translate("tabs:Projekt"),
			icon: <Icon component={HomeIconComponent} className="svg-icon" />,
			selectedIcon: <Icon component={HomeIconComponent} className="selected svg-icon" />,
			onPress: onPressedProjectTab,
			selected: router.view.path.indexOf("/project") > -1,
		},
		{
			key: 'foto',
			title: translate("tabs:Fota"),
			icon: <Icon component={FotoIconComponent} className="svg-icon foto-icon" />,
			selectedIcon: <Icon component={FotoIconComponent} className="selected svg-icon foto-icon" />,
			onPress: onPressedFotoTab,
			selected: router.view.path.indexOf("/foto") > -1,
		},
		{
			key: 'product',
			title: translate("tabs:Produkter"),
			icon: <Icon component={GalleryIconComponent} className="svg-icon" />,
			selectedIcon: <Icon component={GalleryIconComponent} className="selected svg-icon" />,
			onPress: onPressedProductTab,
			selected: router.view.path.indexOf("/product") > -1,
		},
		{
			key: 'rita',
			title: translate("tabs:Rita"),
			icon: <Icon component={OwnproductIconComponent} className="svg-icon special" />,
			selectedIcon: <Icon component={OwnproductIconComponent} className="selected svg-icon special selected-rita-tabs" />,
			onPress: ownIconComponent,
			selected: router.view.path.indexOf("/ritaproduct") > -1,
		},
		{
			key: 'settings',
			title: translate("tabs:Profil"),
			icon: <Icon component={UserIconComponent} className="svg-icon" />,
			selectedIcon: <Icon component={UserIconComponent} className="selected svg-icon" />,
			onPress: onPressedSettingsTab,
			selected: router.view.path.indexOf("/settings") > -1,
		},
	];
	if (isDesktop) {
	} else {
		let removeIndex = -1;
		tabs.map((tab, index) => {
			if (tab.key === 'Search') {
				removeIndex = index;
			}
			return tab;
		});
		if (removeIndex > -1) {
			tabs.splice(removeIndex, 1);
		}
	}
	if (data.currentUser && data.currentUser.userType && data.currentUser.userType.toLocaleLowerCase() === "d") {
		let removeIndex = -1;
		tabs.map((tab, index) => {
			if (tab.key === 'rita') {
				removeIndex = index;
			}
			return tab;
		});
		if (removeIndex > -1) {
			tabs.splice(removeIndex, 1);
		}
	}
	return (
		<TabBar
			unselectedTintColor={colors.lighter}
			tintColor={colors.primary}
			barTintColor={"transparent"}
		>
			{tabs.map((item) => (
				<TabBar.Item
					key={item.key}
					icon={item.icon}
					title={isDesktop ? null : item.title}
					selectedIcon={item.selectedIcon}
					onPress={item.onPress}
					selected={item.selected}
				/>
			))}
		</TabBar>
	);
}
